import { TRarity } from "@pro/common/conf";
import React, { useEffect, useState } from "react";
import { getRarityColor } from "../../helpers";
import Styles from "./Dropdown.module.scss";

enum IconOptions {
	NONE,
	DROPDOWN,
	DROPUP,
}

type DropdownIconType = {
	type: IconOptions
}

const DropdownIcon = ({ type }: DropdownIconType) => {
	if (type === IconOptions.NONE) {
		return <></>
	}

	return (
		<div className={Styles.styleDropdownItemIconWrapper}>
			<div className={type === IconOptions.DROPUP ? Styles.styleDropdownItemDropupIcon : Styles.styleDropdownItemDropdownIcon} />
		</div>
	)
}

type DropdownPropsType = {
	options: {
		[key: string]: number
	}
	activeOption: string
	onChange: (key: string) => void
}

const DropdownRow = ({ data, badge, onClick, backgroundColor, iconType }: { onClick: () => void, backgroundColor: string, iconType: IconOptions, data: string, badge: number }) => (
	<div className={Styles.styleDropdownItem} onClick={onClick} key={data}>
		<div className={Styles.styleDropdownItemRarity} style={{ backgroundColor }} />
		{data}

		<div className={Styles.styleDropdownItemBadge}>
			{badge}
		</div>

		<DropdownIcon type={iconType} />
	</div>
)

export const Dropdown = ({ options, activeOption, onChange }: DropdownPropsType) => {
	const [opened, setOpened] = useState(false)

	useEffect(() => {
		window.addEventListener("click", onClickOutside);

		return () => {
			window.removeEventListener("click", onClickOutside);
		}
	}, [])

	const onClickOutside = (e: any) => { // TODO: find better type for function or input arguments
		if (!(e.target as Element).className.includes("styleDropdownItem")) {
			setOpened(false);
		}
	};

	const handleOnChange = (element: string) => () => {
		onChange(element)

		setOpened(false)
	}

	return (
		<div className={Styles.styleDropdownContainer}>
			<DropdownRow
				data={activeOption}
				badge={options[activeOption]}
				onClick={() => setOpened((previous) => !previous)}
				backgroundColor={getRarityColor(activeOption as TRarity)}
				iconType={opened ? IconOptions.DROPUP : IconOptions.DROPDOWN}
			/>

			{opened && <div className={Styles.styleDropdownChildrenContainer}>
				{Object.keys(options).map(key => {
					const data = key
					const badge = options[key]

					return (
						<DropdownRow
							data={key}
							badge={badge}
							onClick={handleOnChange(data)}
							backgroundColor={getRarityColor(data as TRarity)}
							iconType={IconOptions.NONE}
							key={key}
						/>
					)
				})}
			</div>}
		</div>
	)
}
